import { render } from "./public-add-doctor.vue?vue&type=template&id=3f7a6f34&scoped=true"
import script from "./public-add-doctor.vue?vue&type=script&lang=js"
export * from "./public-add-doctor.vue?vue&type=script&lang=js"

import "./public-add-doctor.vue?vue&type=style&index=0&id=3f7a6f34&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f7a6f34"]])

export default __exports__